import { connect } from "react-redux";

import { FullFormState } from "../../../../../Engine/Core/Store/FullFormState";
import { CandyDispatch } from "../../../../../Engine/Core/Store/CandyReduxTypes";
import { checkByPopd } from "../../../../../Engine/ActionCreators/ErrorLogActionCreators";

import { PopdProtocol } from "./PopdProtocol";

const mapStateToProps = (state: FullFormState) => ({
    protocol: state.errorLog.popdProtocol,
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    runCheckByPopd: () => dispatch((dispatch2, getState, form) => checkByPopd(dispatch2, getState, form)),
});

export const PopdProtocolContainer = connect(mapStateToProps, mapDispatchToProps)(PopdProtocol);
